import { request } from "../../../../services/api.ts"
import type {
  LeadSourceBudgetHistoryEntry,
  LeadSourceBudgetRow,
  LeadSourceBudgetSave
} from "./lead-source-budgets.types.ts"

const BASE_URL = "/templates-management/lead-source-budgets/"

export const getLeadSourceBudgets = () =>
  request.api.get<{ results: LeadSourceBudgetRow[] }>(BASE_URL)

export const getLeadSourceBudgetHistory = (source: string) =>
  request.api.get<{ results: LeadSourceBudgetHistoryEntry[] }>(
    `${BASE_URL}history/`,
    {
      source
    }
  )

export const saveLeadSourceBudget = (data: LeadSourceBudgetSave) =>
  request.api.put<{ changed: boolean; budget: LeadSourceBudgetRow }>(
    BASE_URL,
    data
  )

export const cancelScheduledBudget = (id: string, version: string) =>
  request.api.delete(`${BASE_URL}${id}/`, { version })
